import React from 'react';

function Em({ children }: { children: React.ReactNode }) {
  return <strong className="font-semibold text-zinc-900">{children}</strong>;
}

function EmLight({ children }: { children: React.ReactNode }) {
  return <strong className="font-semibold text-white">{children}</strong>;
}

export default function IpProtectionAgreementContent() {
  return (
    <article className="space-y-6 text-sm md:text-base text-zinc-600 leading-relaxed">
      <p>
        I acknowledge that <Em>LexGat®</Em>, including its software, AI systems, source code,
        interface designs, layouts, workflows, feature arrangements, databases, branding,
        proprietary methodologies, and overall platform experience, is the exclusive intellectual
        property of <Em>LexGat Technologies (Private) Limited</Em>, protected under applicable
        Pakistani intellectual property law including the{' '}
        <Em>Copyright Ordinance, 1962</Em>, and other applicable statutory and contractual
        protections.
      </p>

      <p>
        I understand that if I engage in any <Em>Prohibited Activity</Em>, including but not limited
        to unauthorized copying, reverse engineering, cloning, or using LexGat&apos;s platform, AI
        systems, or proprietary assets to build or assist a competing product, LexGat will terminate
        my access immediately and may pursue civil and criminal legal proceedings, including claims
        for damages and injunctions, criminal prosecution under{' '}
        <Em>Section 66 of the Copyright Ordinance, 1962</Em>, and all other available remedies
        under Pakistani and international law.
      </p>

      <div className="rounded-3xl bg-zinc-900 text-white p-6 md:p-8 shadow-xl shadow-zinc-900/25 border border-zinc-800/80 -mx-1 md:mx-0">
        <p className="text-sm md:text-base leading-relaxed text-zinc-100">
          LexGat actively monitors for unauthorized copying, reverse engineering, cloning, or use of
          its platform, AI systems, or proprietary assets to build or assist a competing product,
          and will respond vigorously including through{' '}
          <EmLight>civil and criminal legal action</EmLight> against any such activity.
        </p>
      </div>
    </article>
  );
}

/** Footer copy with highlighted statutes — used on the agreement page. */
export function IpProtectionAgreementAcceptanceNote() {
  return (
    <p className="text-sm text-zinc-600 leading-relaxed sm:max-w-md">
      By clicking &ldquo;I Acknowledge&rdquo; below, you confirm your electronic acceptance of this{' '}
      <strong className="font-semibold text-zinc-900">Intellectual Property Protection Agreement</strong>, which is
      legally binding on you under <strong className="font-semibold text-zinc-900">Pakistani law</strong>
      , including the{' '}
      <strong className="font-semibold text-zinc-900">Electronic Transactions Ordinance, 2002</strong>
      .
    </p>
  );
}
